<template>
    <v-snackbar
      v-model="$store.getters.msg.show"
      :color="$store.getters.msg.color"
      multi-line="multi-line"
      v-bind:timeout="$store.getters.msg.timeout"
      top="top"
    >
    {{ $store.getters.msg.message }}
    <br />
    <br />
    <v-btn
      dark
      text
      @click="$store.commit('msgOculta')"
    >
      Cerrar
    </v-btn>
    </v-snackbar>
</template>
<style scoped>
</style>
<script>
export default {
    name: 'MsgComponent',
    data: () => ({
    }),
    methods: {
    }
}
</script>
